import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'peps-marvel-rivals-logo',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './marvel-rivals-logo.component.html',
})
export class MarvelRivalsLogoComponent {
	@Input() sizeSvg: string = '';

}
